export default (router, args) => {
  console.info('router redirect', new Error().stacktrace, args);
  router.push.apply(router, args);
};
